import { UserGroupModel } from "../groups/user-group-model";
import { UserDetailModel } from "./user-detail.model";

export class UserUpdateModel extends UserDetailModel {

  constructor() {
    super();
    this.DeletedGroups = [];
    this.AddedGroups = [];
    this.ModifiedGroups = [];
  }

  public DeletedGroups: Array<number>;

  public AddedGroups: Array<UserGroupModel>;

  public ModifiedGroups: Array<UserGroupModel>;
}
